import { render } from "./OurTeamSheet.vue?vue&type=template&id=5cf4576d&ts=true"
import script from "./OurTeamSheet.vue?vue&type=script&lang=ts"
export * from "./OurTeamSheet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__